import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Section} from 'constants/NavConstants';
import {OligoAwareFolderItemType} from 'constants/RegistryConstants';
import BioentitySearchView from 'molbio/BioentitySearchView';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal, {ModalButton} from 'ui-library/modals/Modal';
import {RowSelectionMode} from 'ui-library/scrollable/ScrollableTableConstants';

interface ComponentSearchModalProps {
  onRequestSubmit?: (selectedIds: Array<string> | null) => void;
}

export default function ComponentSearchModal({onRequestSubmit}: ComponentSearchModalProps): JSX.Element {
  const [selectedBioentityIds, setSelectedBioentityIds] = useState<Array<string>>([]);
  const allowedComponentTypes: Array<OligoAwareFolderItemType> = [ModelTypeConstants.PROTEIN];
  if (BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE) {
    allowedComponentTypes.push(ModelTypeConstants.MOLECULE);
  }

  const buttons: Array<ModalButton> = [
    {text: 'Cancel', cancel: true},
    {
      text: 'Add Components',
      style: ButtonStyle.SECONDARY,
      submit: true,
      disabled: selectedBioentityIds.length === 0,
    },
  ];

  return (
    <Modal
      title="Search for structure prediction components"
      buttons={buttons}
      onRequestClose={() => {
        onRequestSubmit?.(null);
      }}
      onRequestSubmit={() => {
        onRequestSubmit?.(selectedBioentityIds);
      }}
      fullWidth={true}
      fullHeight={true}
      scrollable={false}
      bodyPadded={false}
    >
      <div className={css(styles.sequenceSearchView)}>
        <BioentitySearchView
          navSection={Section.MODEL_HUB_STRUCTURE_PREDICTION}
          availableTypes={allowedComponentTypes}
          selectedBioentityIds={selectedBioentityIds}
          setSelectedBioentityIds={setSelectedBioentityIds}
          rowSelectionMode={RowSelectionMode.MULTIPLE}
        />
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  sequenceSearchView: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});
